import React from "react"
import { connect } from "react-redux"

// These are regular React components we will write soon
import MessageModal from "./MessageModal"
import ConfirmModal from "./ConfirmModal"
import IFrameModal from "./IFrameModal"
import VoucherBundleModal from "./VoucherBundleModal"

const MODAL_COMPONENTS = {
	MESSAGE: MessageModal,
	CONFIRM_MESSAGE: ConfirmModal,
	IFRAME: IFrameModal,
	VOUCHER_BUNDLE: VoucherBundleModal,
	/* other modals */
}

const ModalRoot = (props) => {
	const { modalType, modalProps, isOpen } = props
	if (!modalType) {
		return null
	}

	const SpecificModal = MODAL_COMPONENTS[modalType]
	return (
		<SpecificModal
			className="modal"
			overlayClassName="modal-overlay"
			closeTimeoutMS={200}
			isOpen={isOpen}
			{...modalProps}
		/>
	)
}

export default connect((state) => state.modal)(ModalRoot)
